<template>
  <el-dialog
    title="编辑资产"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <!-- :model="form" -->
    <el-form
      v-if="formData"
      size="small"
      :model="copyForm"
      :rules="rules"
      ref="copyForm"
      v-loading="formLoading"
    >
      <!-- 动态渲染 -->
      <template v-if="formItems">
        <el-form-item
          v-for="item in formItems"
          :label="item.text"
          :label-width="formLabelWidth"
          :key="item.name"
          
        >
        <!-- :prop="item.name" -->
          <template v-if="item.type === 'input'">
            <el-input
              v-model="copyForm[item.name]"
              autocomplete="off"
              :disabled="item.disabled"
              :placeholder="item.placeholder"
            ></el-input>
          </template>
          <template v-if="item.type === 'number'">
            <el-input
              v-model="copyForm[item.name]"
              type="number"
              autocomplete="off"
              :disabled="item.disabled"
              :placeholder="item.placeholder"
            ></el-input>
          </template>
          <!-- <template v-if="item.type === 'radio'">
            <el-radio-group v-model="copyForm[item.name]">
              <el-radio
                v-for="option in item.option"
                :key="option.value"
                :label="option.value"
                :disabled="item.disabled"
                >{{ option.label }}</el-radio
              >
            </el-radio-group>
          </template> -->
          <!-- v-if="item.text === '资产类型'" -->
          <template v-if="item.type === 'radio'">
            <el-select v-model="copyForm[item.name]" placeholder="请选择" :disabled="item.disabled">
              <el-option
                v-for="option in item.option"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              >
                {{ option.label }}
              </el-option>
            </el-select>
            <!-- {{item.name}},{{copyForm[item.name]}}+++++{{item.option}} -->
          </template>
          <!-- <el-select @change="provinceChange" v-model="form.province_name" filterable  placeholder="请选择省份">
              <el-option
                  v-for="item in province_options"
                  :key="item.id"
                  :label="item.name"
                  :value="item">
              </el-option>
          </el-select> -->

          <template v-if="item.type === 'autocomplete'">
            <el-autocomplete
              v-model="copyForm[item.name]"
              :fetch-suggestions="querySearchAsync(item)"
              :placeholder="item.placeholder"
              :disabled="item.disabled"
              placement="bottom"
              v-bind="item.option"
              @change.native="handleChange"
              @select="handleSelect"
            >
            </el-autocomplete>
          </template>

          <template v-if="item.type === 'datetime'">
            <el-date-picker
              type="datetime"
              v-model="copyForm[item.name]"
              :placeholder="item.placeholder"
              :disabled="item.disabled"
            >
            </el-date-picker>
          </template>

        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button
        type="primary"
        @click="submitApi"
        :loading="loading && open_edit"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { deepClone } from "@/utils/base.js";

export default {
  data() {
    return {
      copyForm: {},
      rules: {},
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: false,
      /* 类型 */
      typeList: [],
      /* 表单Items */
      formLoading: false,
      loading: false,
      assets_type :'',
    };
  },
  props: ["on_edit","open_edit", "formData", "formItems", "autocompleteOptions"],
  created() {
    this.init();
  },
  watch: {
    on_edit(){

    }
  },
  methods: {
    /* 初始化数据 */
    async init() {
      this.dialogVisible = this.open_edit;
      this.copyForm = this.getFormData();
      this.rules = this.getFormRules(this.formItems);
      // console.log('this.copyForm==>',this.copyForm);
      // console.log('this.formItems==>',this.formItems)
      let index=this.formItems.findIndex((item)=>item.text=='用户');
      // console.log(index)
      this.formItems[index].text="所属用户";
    },

    /* 获取表单规则 */
    getFormRules(options) {
      return options.reduce((acc, cur) => {
        if (cur.rules) {
          const name = cur.name;
          acc = { ...acc, [name]: cur.rules };
        }
        return acc;
      }, {});
    },

    /* 获取表单数据 */
    getFormData() {
      const temp = deepClone(this.formData);
      if (
        temp.user_id != "" &&
        temp.user_id != undefined &&
        temp.user_id != null
      ) {
        const res =
          this.autocompleteOptions.find(item => {
            return item.user_id == temp.user_id;
          }) || {};
        temp.other_user_name = res.nickName;
      }
      return temp;
    },

    // 提交api表单
    submitApi() {
      this.$refs.copyForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.formLoading=true;
          this.$emit("submitForm", this.copyForm);
        } else {
          return false;
        }
      });
    },

    /* 处理搜索选中 */
    handleSelect(item) {
      this.copyForm.user_id = item.user_id;
    },

    /* 处理搜索框值改变 */
    handleChange(event) {
      const value = event.target.value;
      const res = this.autocompleteOptions.find(
        item => item.nickName === value
      );
      if (res) {
        this.copyForm.user_id = res.user_id;
      } else {
        this.copyForm.other_user_name = null;
      }
    },

    /* 搜索框 */
    querySearchAsync(item) {
      return (queryString, cb) => {
        const key = item.option ? item.option["value-key"] : "value";
        const results = queryString
          ? this.autocompleteOptions.filter(this.filter(queryString, key))
          : this.autocompleteOptions;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 300);
      };
    },

    /* 过滤搜索 */
    filter(queryString, key = "value") {
      return state => {
        return (state[key] + "").includes(queryString);
      };
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog");
    }
  },
  updated(){
    if(this.on_edit && this.on_edit == false)  {
      this.loading = false;
      this.formLoading=false;
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user_asset/all/part/Edit.vue